import jsPDF from "jspdf";
import myImage from "../assets/img/img/logopdf.png";
import logotoulouse from "../assets/img/img/logotoulouse.png";
import logobrive from "../assets/img/img/logobrive.png";
import gmail from "../assets/img/img/gmail.png";
import phone from "../assets/img/img/phone.png";
import cgvClient from "../assets/img/img/cgv-client.jpg";

// Fonctions utilitaires pour les dates
const formatJsDate2 = (date) => {
  const newDate = new Date(date);
  const day = String(newDate.getDate()).padStart(2, "0");
  const month = String(newDate.getMonth() + 1).padStart(2, "0");
  const year = newDate.getFullYear();
  return `${month}${year}`;
};

const formatJsDate = (date) => {
  const newDate = new Date(date);
  const day = String(newDate.getDate()).padStart(2, "0");
  const month = String(newDate.getMonth() + 1).padStart(2, "0");
  const year = newDate.getFullYear();
  return `${day}/${month}/${year}`;
};

/**
 * Génère un PDF pour un devis - FONCTION ORIGINALE de ClientDetail.jsx
 * @param {Object} quotation - Objet devis
 * @param {boolean} viewOnly - Si true, ouvre le PDF dans un nouvel onglet, sinon télécharge
 * @param {Function} setIsLoadingQuotation - Fonction pour gérer l'état de chargement (optionnel)
 * @returns {void}
 */
export const generatePDF = (quotation, viewOnly = false, setIsLoadingQuotation = null) => {
  console.log(quotation);
  
  if (setIsLoadingQuotation) {
    setIsLoadingQuotation(true);
  }

  const pdf = new jsPDF({
    unit: "mm",
    format: [210, 297],
  });

  const img = new Image();
  if (quotation.agency?.name === "CAPENEO") {
    img.src = logotoulouse;
    pdf.addImage(img, "PNG", 14, 10, 40, 24);
  } else if (quotation.agency?.name === "J'M CAPENEO") {
    img.src = logobrive;
    pdf.addImage(img, "PNG", 24, 14, 32, 24);
  } else {
    img.src = myImage;
    pdf.addImage(img, "PNG", 14, 10, 40, 24);
  }

  const gmailImg = new Image();
  gmailImg.src = gmail;

  const phoneImg = new Image();
  phoneImg.src = phone;

  pdf.setFontSize(14);
  pdf.setFont("Helvetica", "Bold");
  pdf.text(quotation.agency?.name || "AGENCE", 24, 45);
  pdf.setFontSize(9);
  pdf.setFont("Helvetica", "normal");
  pdf.text(quotation.agency?.address || "", 15, 50);
  pdf.text((quotation.agency?.postCode || "") + " " + (quotation.agency?.town || ""), 15, 55);
  pdf.text("SIRET  : " + (quotation.agency?.siret || ""), 15, 60);
  pdf.text("TVA n° : " + (quotation.agency?.tva || quotation.agency?.TVA || ""), 15, 65);
  pdf.addImage(gmailImg, "PNG", 15, 67, 3, 3);

  pdf.text(" : " + (quotation.agency?.email || ""), 18, 69.5);
  pdf.addImage(phoneImg, "PNG", 15, 71.5, 3, 3);
  pdf.text(" : " + (quotation.agency?.phone || ""), 18, 74);
  
  // Contact créateur (optionnel pour prévisualisation)
  if (quotation.creator) {
    pdf.text(
      "Contact : " +
        quotation.creator.firstname +
        " " +
        quotation.creator.lastname,
      15,
      79.5,
    );
  }

  pdf.setFontSize(14);
  pdf.setFont("Helvetica", "Bold");
  if (quotation.quotationNumber && quotation.quotationNumber !== 'PREVIEW') {
    pdf.text(
      "Devis n° " +
        formatJsDate2(quotation.createdAt) +
        "-" +
        quotation.quotationNumber.toString().padStart(5, 0),
      110,
      45,
    );
  } else {
    pdf.text("Devis provisoire", 110, 45);
  }

  pdf.setFontSize(9);
  pdf.setFont("Helvetica", "normal");

  pdf.text("Date : ", 110, 50);
  pdf.text(formatJsDate(quotation.createdAt), 120, 50);
  
  if (quotation.expiryDate) {
    pdf.text("Date d'expiration :", 110, 55);
    pdf.text(formatJsDate(quotation.expiryDate), 137, 55);
  }

  pdf.setFontSize(10);
  pdf.setFont("Helvetica", "Bold");
  pdf.text("Adresse de facturation :", 15, 95);

  pdf.setFontSize(9);
  pdf.setFont("Helvetica", "normal");
  
  // Gestion de l'adresse de facturation (fallback si pas de CP à 5 chiffres)
  let partieAvant = "";
  let codePostal = "";
  let partieApres = "";
  if (quotation.addressFacturation) {
    const addressFacturation = quotation.addressFacturation.toString().trim();
    const addressMatch = addressFacturation.match(/^(.*?)\b(\d{5})\b(.*)$/);
    if (addressMatch) {
      [partieAvant, codePostal, partieApres] = addressMatch
        .slice(1)
        .map((str) => str.trim());
    } else {
      partieAvant = addressFacturation;
    }
    try {
      pdf.text(partieAvant, 15, 100);
      if (codePostal || partieApres) {
        pdf.text(codePostal + " " + partieApres, 15, 105);
      }
    } catch (e) {
      console.log(e);
      pdf.text(addressFacturation, 15, 100);
    }
  }

  pdf.setFontSize(12);
  pdf.setFont("Helvetica", "Bold");
  pdf.text((quotation.client?.companyName || quotation.client?.denomination || "CLIENT").toUpperCase(), 110, 80);

  pdf.setFontSize(9);
  pdf.setFont("Helvetica", "normal");
  
  // Contact client : on retire email (@) et téléphone (chiffres)
  if (quotation.contact) {
    const contact = quotation.contact
      .toString()
      .split(" ")
      .filter((part) => part && !part.includes("@") && !/\d/.test(part))
      .join(" ")
      .trim();
    pdf.text(contact.toUpperCase(), 110.5, 85);
  }
  
  // Adresse client
  if (quotation.addressFacturation && partieAvant && codePostal && partieApres) {
    pdf.text(partieAvant, 110.5, 90);
    pdf.text(codePostal + " " + partieApres, 110.5, 95);
  }
  
  pdf.text("SIRET : " + (quotation.client?.siret || ""), 110.5, 100);
  pdf.text("TVA : " + (quotation.client?.TVA || ""), 110.5, 105);

  // Fonction utilitaire pour diviser les chaînes
  const splitStringWithoutCuttingWords = (str, maxLength) => {
    if (!str) return [];
    const words = str.split(' ');
    const result = [];
    let currentLine = '';

    for (const word of words) {
      if ((currentLine + word).length <= maxLength) {
        currentLine += (currentLine ? ' ' : '') + word;
      } else {
        if (currentLine) result.push(currentLine);
        currentLine = word;
      }
    }
    if (currentLine) result.push(currentLine);
    return result;
  };

  pdf.setTextColor(0, 0, 0);
  pdf.setFontSize(12);
  pdf.setFont("Helvetica", "bold");
  pdf.setTextColor(9, 132, 227);
  pdf.setDrawColor(9, 132, 227);

  // Vérifier s'il y a des produits
  if (!quotation.products || quotation.products.length === 0) {
    pdf.setTextColor(0, 0, 0);
    pdf.setFont("Helvetica", "normal");
    pdf.text("Aucun service ou prime ajouté", 15, 170);

    if (setIsLoadingQuotation) {
      setIsLoadingQuotation(false);
    }

    const pdfBlob = pdf.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    if (viewOnly) {
      window.open(pdfUrl, "_blank");
    } else {
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `Devis_${quotation.quotationNumber || 'Provisoire'}_${formatJsDate2(quotation.createdAt)}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
    }
    return;
  }

  const mainProduct = quotation.products[0]?.product || "";

  // Gestion des différents types de produits (Vacation = Placement, comme admin)
  if (mainProduct === "Placement" || mainProduct === "Vacation") {
    pdf.roundedRect(26, 115, 160, 30, 1, 1);
    pdf.text(mainProduct.toUpperCase(), 95, 120);
    pdf.line(95, 122, 122, 122);

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");
    pdf.setTextColor(0, 0, 0);

    pdf.text(
      "Vous nous mandatez pour recruter au sein de votre entreprise, un poste en CDD ou CDI.",
      46,
      130,
    );
    pdf.text(
      "Le contrat, la DPAE et la fiche de paie sont établis par vos soins. Vous êtes l'employeur.",
      46,
      135,
    );
    pdf.text("Vous recevrez une seule facture pour le placement", 57, 140);
  }

  if (
    mainProduct === "Délégation" ||
    mainProduct === "Gestion"
  ) {
    pdf.roundedRect(15, 110, 92, 35, 1, 1);
    pdf.roundedRect(110, 110, 92, 35, 1, 1);
    pdf.text("DELEGATION", 47, 115);
    pdf.line(47, 117, 75, 117);
    pdf.text("GESTION", 145, 115);
    pdf.line(145, 117, 164, 117);

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");
    pdf.setTextColor(0, 0, 0);

    pdf.text("Vous nous mandatez pour", 17, 125);
    pdf.setFont("Helvetica", "bold");
    pdf.text("recruter", 55, 125);
    pdf.setFont("Helvetica", "normal");
    pdf.text("   et", 65, 125);
    pdf.setFont("Helvetica", "bold");
    pdf.text("  gérer", 70, 125);
    pdf.setFont("Helvetica", "normal");
    pdf.text(" l'administratif", 80, 125);
    pdf.text("de ", 17, 130);
    pdf.setFont("Helvetica", "bold");
    pdf.text("notre", 21, 130);
    pdf.setFont("Helvetica", "normal");
    pdf.text("recrue. Le contrat, la DPAE et la fiche de paie sont", 30, 130);
    pdf.text(
      "établis par nous, qui sommes l'employeur. Vous avez à charge",
      17,
      135,
    );
    pdf.text(
      "la sécurité du salarié. Vous recevrez une facture mensuelle.",
      17,
      140,
    );

    pdf.text("Vous nous mandatez pour", 112, 125);
    pdf.setFont("Helvetica", "bold");
    pdf.text("gérer", 150, 125);
    pdf.setFont("Helvetica", "normal");
    pdf.text("simplement l'administratif", 159, 125);
    pdf.text("de", 112, 130);
    pdf.setFont("Helvetica", "bold");
    pdf.text("votre", 116, 130);
    pdf.setFont("Helvetica", "normal");
    pdf.text(
      "recrue. Le contrat, la DPAE et la fiche de paie sont",
      125,
      130,
    );
    pdf.text(
      "établis par nous, qui sommes l'employeur. Vous avez à charge",
      112,
      135,
    );
    pdf.text(
      "la sécurité du salarié. Vous recevrez une facture mensuelle.",
      112,
      140,
    );
  }

  pdf.setTextColor(0, 0, 0);

  pdf.setFillColor(9, 132, 227);
  pdf.setDrawColor(9, 132, 227);
  pdf.rect(15, 155, 180, 10, "F");

  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(10);
  pdf.setFont("Helvetica", "bold");

  if (
    mainProduct === "Délégation" ||
    mainProduct === "Gestion"
  ) {
    let height = 170;

    pdf.text("Designation", 25, 161);
    pdf.text("Taux horaire", 60, 161);
    pdf.text("Coefficient", 95, 161);
    pdf.text("Prix HT/heure", 130, 159);
    pdf.text("travaillée", 135, 163);
    pdf.text("Observation", 165, 161);

    pdf.setFontSize(10);
    pdf.setFont("Helvetica", "normal");
    pdf.setTextColor(0, 0, 0);
    pdf.setDrawColor(0, 0, 0);

    quotation.products.map((product, idx) => {
      if (product.type === "Prime" || product.isPrime)
        pdf.text("Prime : " + (product.product || ""), 20, height);
      else if (product.type === "Indemnité")
        pdf.text("Indemnité : " + (product.product || ""), 20, height);
      else if (product.type === "Autre")
        pdf.text(product.product || "", 20, height);
      else {
        pdf.text((product.product || "") + " H/F", 20, height);
        const poste = splitStringWithoutCuttingWords(product.poste || "", 24);
        for (let i = 0; i < poste.length; i++) {
          pdf.text(poste[i], 20, height + 5);
          height += 5;
        }
      }
      const hasTaux = product.taux !== "" && product.taux != null;
      const hasCoeff =
        product.coefficient !== "" && product.coefficient != null;
      if (hasTaux) {
        pdf.text(parseFloat(product.taux).toFixed(2) + "€", 65, height);
      }
      if (hasCoeff) {
        pdf.text(String(product.coefficient), 105, height);
      }
      if (hasTaux && hasCoeff) {
        pdf.text(
          (
            parseFloat(product.taux) * parseFloat(product.coefficient)
          ).toFixed(2) + "€",
          140,
          height,
        );
      }
      pdf.text(product.comment || "", 165, height);
      height += 5;
      pdf.setTextColor(128, 128, 128);
      pdf.setDrawColor(128, 128, 128);
      if (product.minimumHours) {
        pdf.text(
          "Nombre d'heures minimales avant embauche sans facturation : " +
            product.minimumHours +
            "h",
          50,
          height,
        );
        height += 3;
      }

      if (idx === quotation.products.length - 1) {
        pdf.setDrawColor(0, 0, 0);
        pdf.setLineWidth(0.5);
      }
      pdf.line(15, height, 195, height);
      pdf.setTextColor(0, 0, 0);
      pdf.setDrawColor(0, 0, 0);
      height += 7;
      if (height > 260) {
        pdf.addPage();
        height = 10;
      }
    });

    height += 10;
    if (height > 250) {
      pdf.addPage();
      height = 10;
    }

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");

    pdf.text("Nom et qualité du signataire :", 15, height);
    pdf.text("Date : " + formatJsDate(new Date()), 15, height + 5);

    pdf.text(String(quotation.client?.tvaRate || ""), 120, height);
    pdf.text(
      "Conditions de paiement : " + (quotation.client?.facturation || ""),
      120,
      height + 5,
    );
    pdf.text("Moyen de règlement : Virement/Chèque/CB", 120, height + 10);
  }

  // Gestion du placement / vacation
  if (mainProduct === "Placement" || mainProduct === "Vacation") {
    let height = 170;

    pdf.text("Designation", 25, 161);
    pdf.text("Quantité", 68, 161);
    pdf.text("PU (HT)", 110, 161);
    pdf.text("Montant (HT)", 160, 161);

    pdf.setFontSize(10);
    pdf.setFont("Helvetica", "normal");
    pdf.setTextColor(0, 0, 0);
    pdf.setDrawColor(0, 0, 0);

    quotation.products.map((product, idx) => {
      pdf.text((product.product || "") + " H/F", 20, height);
      pdf.text(product.poste || "", 20, height + 5);
      height += 5;
      const taux = parseFloat(product.taux);
      const coeff = parseFloat(product.coefficient);
      const safeTaux = Number.isFinite(taux) ? taux : 0;
      const safeCoeff = Number.isFinite(coeff) ? coeff : 0;
      pdf.text(safeTaux.toFixed(2) + "€", 110, height);
      pdf.text(String(product.coefficient ?? ""), 75, height);
      pdf.text((safeTaux * safeCoeff).toFixed(2) + "€", 175, height);
      height += 5;
      pdf.setTextColor(128, 128, 128);
      pdf.setDrawColor(128, 128, 128);

      if (idx === quotation.products.length - 1) {
        pdf.setDrawColor(0, 0, 0);
        pdf.setLineWidth(0.5);
      }
      pdf.line(15, height, 195, height);
      pdf.setTextColor(0, 0, 0);
      pdf.setDrawColor(0, 0, 0);
      height += 7;
      if (height > 260) {
        pdf.addPage();
        height = 10;
      }
    });

    if (height > 250) {
      pdf.addPage();
      height = 10;
    }

    pdf.setFillColor(135, 177, 255);
    pdf.setDrawColor(9, 132, 227);
    height += 6;
    pdf.setTextColor(255, 255, 255);
    pdf.setFont("Helvetica", "Bold");

    pdf.setTextColor(0, 0, 0);
    pdf.setFont("Helvetica", "normal");

    pdf.text("Total HT", 110, height);
    pdf.text(
      quotation.products
        .reduce((total, item) => total + parseFloat(item.taux), 0)
        .toFixed(2) + " €",
      174,
      height,
    );

    height += 10;

    pdf.text(
      (
        quotation.products.reduce(
          (total, item) => total + parseFloat(item.taux),
          0,
        ) * 0.2
      ).toFixed(2) + " €",
      174,
      height,
    );
    height += 10;
    pdf.setFillColor(9, 132, 227);
    pdf.rect(105, height - 7, 90, 10, "F");
    pdf.setTextColor(255, 255, 255);
    pdf.text("Total TTC", 110, height);
    pdf.text(
      (
        parseFloat(
          quotation.products.reduce(
            (total, item) => total + parseFloat(item.taux),
            0,
          ) * 0.2,
        ) +
        parseFloat(
          quotation.products.reduce(
            (total, item) => total + parseFloat(item.taux),
            0,
          ),
        )
      ).toFixed(2) + " €",
      174,
      height,
    );

    pdf.setTextColor(0, 0, 0);
    height += 10;

    if (height >= 270) pdf.addPage();

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");

    if (height > 280) {
      pdf.addPage();
      height = 10;
    }

    // Gestion des commentaires pour placement
    if (quotation.products[0].comment2) {
      const comment2 = splitStringWithoutCuttingWords(
        quotation.products[0].comment2,
        90,
      );
    }

    if (quotation.products[0].comment) {
      const paymentCondition = splitStringWithoutCuttingWords(
        "Conditions de paiement : " + quotation.products[0].comment,
        70,
      );
    }

    if (quotation.products[0].comment2) {
      const replaceCondition = splitStringWithoutCuttingWords(
        "Conditions de remplacement : " + quotation.products[0].comment2,
        70,
      );
    }

    pdf.text("Nom et qualité du signataire :", 15, height);
    pdf.text("Date : " + formatJsDate(new Date()), 15, height + 5);
    pdf.text("Moyen de règlement : Virement/Chèque/CB", 90, height);
  }

  // Pied de page
  pdf.text(
    `J'm intérim - SAS au capital de 80 000 € - 4 Avenue Laurent Cély, Hall A, 92600 Asnières sur Seine, France`,
    25,
    280,
  );
  pdf.text(
    "SIRET : 91912551800010 - Code APE : 7820z - N° de TVA : FR52919125518",
    50,
    285,
  );

  // Ajouter la page CGV
  pdf.addPage();
  pdf.addImage(cgvClient, "PNG", 10, 10, 198, 282);

  // Génération finale du PDF
  const pdfBlob = pdf.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);

  if (viewOnly) {
    // Pour la visualisation, ouvrir dans un nouvel onglet
    window.open(pdfUrl, "_blank");
  } else {
    // Pour le téléchargement, déclencher le téléchargement
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = `Devis_${quotation.quotationNumber || 'Provisoire'}_${formatJsDate2(quotation.createdAt)}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Libérer l'URL après le téléchargement
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
  }

  if (setIsLoadingQuotation) {
    setIsLoadingQuotation(false);
  }
};
